import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";
import { IDuplicateIframePayload } from "@app/dashboard/types/innerLayout/iframes/duplicate-iframe";

export const duplicateIframe = ( payload: IDuplicateIframePayload) => {
  return axiosPrivate.post(`/dashboard/api/v1/iframes`, payload);
};